import { render } from "./achieveAdd.vue?vue&type=template&id=39b7cf6b&scoped=true"
import script from "./achieveAdd.vue?vue&type=script&lang=js"
export * from "./achieveAdd.vue?vue&type=script&lang=js"

import "./achieveAdd.vue?vue&type=style&index=0&id=39b7cf6b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b7cf6b"]])

export default __exports__